import styled from 'styled-components';

export const TabWrapper = styled.div`
  .Mui-selected .MuiTypography-root {
    color: ${({ theme }) => theme.selectedTabColor};
  }
`;
